// En producción usamos URL relativa: /api/* es servido por Vercel (api/index.js)
// En desarrollo apuntamos al backend Express local
const isProd = process.env.NODE_ENV === 'production';
const LOCAL_DEV_API = 'http://localhost:5000';

/** Evita https://dominio.com/api + /api/... → HTML 404 y "Unexpected token '<'" */
export function normalizeApiBaseUrl(raw) {
  let base = String(raw ?? '').trim();
  if (!base) return '';
  base = base.replace(/\/+$/, '');
  if (base.endsWith('/api')) {
    base = base.slice(0, -4);
  }
  return base;
}

function isLocalDevHost(hostname) {
  const h = String(hostname || '').toLowerCase();
  return h === 'localhost' || h === '127.0.0.1';
}

/**
 * Base URL de la API en el navegador.
 * En contsuite.com.ar siempre usamos rutas relativas /api (ignora REACT_APP mal seteado).
 */
export function getRuntimeApiBaseUrl() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname.toLowerCase();

    if (isLocalDevHost(host)) {
      const fromEnv = normalizeApiBaseUrl(process.env.REACT_APP_API_URL);
      if (fromEnv) return fromEnv;
      // Dev: API directa al Express (evita 404 HTML del dev server si el proxy falla)
      return LOCAL_DEV_API;
    }

    if (host === 'contsuite.com.ar' || host === 'www.contsuite.com.ar' || host.endsWith('.vercel.app')) {
      return '';
    }
  }

  return normalizeApiBaseUrl(
    process.env.REACT_APP_API_URL || (isProd ? '' : LOCAL_DEV_API)
  );
}

/** Preferí apiUrl() en código nuevo */
export function apiUrl(path) {
  const base = getRuntimeApiBaseUrl();
  const normalized = path.startsWith('/') ? path : `/${path}`;
  return base ? `${base}${normalized}` : normalized;
}
